export default __webpack_public_path__ + "static/media/depression.a02a2f31.svg";